<template>
<section class="servicesFilter">
  <div class="container">
    <button class="button__transparent button_middle" @click=" fDesign ()" v-bind:class="{ button: servicesFilterStatus === 'design'}">3D-дизайн</button>
    <button class="button__transparent button_middle" @click=" fRepair ()" v-bind:class="{ button: servicesFilterStatus === 'repair'}">Ремонт</button>
  </div>
</section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ServicesFilter',
  components: {
  },
  methods: {
    ...mapActions ([
        'filterIsDesign',
        'filterIsRepair'
    ]),
    fDesign () {
      this.filterIsDesign ()
    },
    fRepair () {
      this.filterIsRepair ()
    }
  },
  computed: {
    ...mapGetters ([
        'servicesFilterStatus'
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.servicesFilter {
  padding: 45px 0;
  @media (max-width: 575.98px) {
    padding: 20px 0;
  }
  .container {
    display: flex;
    justify-content: center;
    button {
      margin-right: 20px;
      font-size: 1.6rem;
      font-weight: 300;
      @media (max-width: 575.98px) {
        font-size: 1.2rem;
      }
      &.button {
        border: 1px solid #000;
        background-color: #000;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .1s linear all;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
